import React from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "../Dialog";
import Button from "../Button";
import { Icon } from "@iconify/react";
import { Typography } from "../Typography";

const IdeaAcceptedDialog = ({ 
  isOpen, 
  onClose,
  title = "Idea Accepted",
  description = "This idea will now be visible as an engagement. Students associated with this engagement will now be able to schedule meetings with you.",
  buttonLabel = "View Engagements",
  showViewButton = true
}) => {
  const navigate = useNavigate();

  const handleViewEngagements = () => {
    onClose();
    navigate("/engagements");
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="max-w-md"
    >
      <div className="flex flex-col items-center gap-6 py-2">
        {/* Success Icon with Ripple Effect */}
        <div className="relative">
          {/* Ripple circles */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 rounded-full bg-green-100 opacity-50 animate-ping"></div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-24 h-24 rounded-full bg-green-50 opacity-30"></div>
          </div>
          {/* Main icon */}
          <div className="relative w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
            <Icon
              icon="lucide:check"
              className="h-8 w-8 text-green-600"
            />
          </div>
        </div>

        {/* Title */}
        <div className="text-center">
          <Typography as="h2" className="text-2xl font-bold text-primary-900">
            {title}
          </Typography>
        </div>

        {/* Description */}
        <div className="text-center">
          <Typography as="p" className="text-sm text-tertiary-600 leading-relaxed">
            {description}
          </Typography>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-end gap-3 w-full pt-4">
          <Button
            variant="secondary"
            size="medium"
            onClick={onClose}
            className="bg-white border-slate-200 text-slate-700 hover:bg-slate-50"
          >
            Close
          </Button>
          {showViewButton && (
            <Button
              variant="primary"
              size="medium"
              onClick={handleViewEngagements}
              className="bg-purple-600 hover:bg-purple-700 text-white"
            >
              {buttonLabel}
            </Button>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default IdeaAcceptedDialog;

